import type { SVGProps } from 'react';

const LogoVilla = (props: SVGProps<SVGSVGElement>) => (
  <svg
    enableBackground="new -204 330.8 202.4 135.5"
    height={135.5}
    viewBox="-204 330.8 202.4 135.5"
    width={202.4}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g preserveAspectRatio="xMaxYMid meet" transform="translate(-12.72 -12.19)">
      <path
        d="m11.1 388.8c0 11.5-9.8 20.9-21.9 20.9s-21.9-9.3-21.9-20.9c0-11.5 9.8-20.9 21.9-20.9s21.9 9.4 21.9 20.9"
        fill="#e30613"
      />
      <path d="m-2.6 388.8-8.2-7.8-8.2 7.8 8.2 7.8zm-8.2 14.5-15.3-14.5 15.3-14.5 15.3 14.5z" fill="#fff" />
      <g fill="#274149">
        <path d="m-130.4 398.8-23.3 48.2c-1.2 2.7-4 4.4-7 4.2-3 .2-5.8-1.5-7-4.2l-23.5-48.2h10.8l19.6 40.4 19.8-40.4z" />
        <path d="m-120.1 450.6h-10.3v-51.8h10.3zm1.6-63.6c0 1.6-.8 3.1-2.1 4.1-1.3 1.2-3.1 1.8-4.9 1.8-1.7 0-3.4-.6-4.8-1.7-1.3-1-2-2.5-2-4.1s.7-3.2 1.9-4.2c1.3-1.2 3.1-1.8 4.8-1.8 1.8-.1 3.5.6 4.9 1.7 1.4 1 2.2 2.6 2.2 4.2" />
        <path d="m-113.3 380.5h10.3v70.1h-10.3z" />
        <path d="m-96.2 380.5h10.3v70.1h-10.3z" />
        <path d="m-41.6 435.9v-9.9c0-1.1-.8-1.6-2.4-1.6h-20c-5 0-7.4 2.1-7.4 6.4v5.1c0 1.7.8 3.3 2.2 4.3 1.6 1.1 3.5 1.7 5.4 1.6h15c4.8-.1 7.2-2.1 7.2-5.9m10.3 1.7c.1 3.5-1.3 7-3.9 9.4s-6.2 3.6-10.7 3.6h-19.8c-4.8 0-8.5-1-11.4-3.1-3-2.1-4.7-5.6-4.6-9.3v-9.3c0-4.1 1.4-7.2 4.1-9.5s6.5-3.4 11.3-3.4h24.8c-.1-2.9-.6-5-1.5-6.2-1.1-1.5-3.3-2.3-6.6-2.3h-25.9v-8.7h27.3c11.3 0 16.9 4.4 16.9 13.1z" />
      </g>
    </g>
  </svg>
);
export default LogoVilla;
